import { store } from '../Redux/store';
import { persistor } from '../Redux/store';
import { actionCreators } from '../Redux';

export const clearReduxState = async () => {
  // Dispatch actions to clear each reducer state
  store.dispatch(actionCreators.addAuthenticateUser(null));
  store.dispatch(actionCreators.addSwitchedSociety(null));
  store.dispatch(actionCreators.addGroupWiseLevelData(null));
  store.dispatch(actionCreators.userHasSocieties([]));
  store.dispatch(actionCreators.userHasRoleWithPermission([]));
  store.dispatch(actionCreators.switchedRole(null));

  // Purge the persisted store
  await persistor.purge();
}; 